<template>
  <VeeField
    v-if="useCartFormData().value.invoiceAddress != null"
    v-slot="{ field, meta }"
    v-model="useCartFormData().value.invoiceAddress!.title"
    name="title"
    rules="required|salutation"
  >
    <select
      v-bind="field"
      :class="inputClass + (meta.touched ? (meta.valid ? ' valid ' : ' invalid ') : '')"
      aria-label="Auswahl Anrede"
      @change="change(($event?.target as HTMLSelectElement)?.value)"
    >
      <option
        value="UNKNOWN"
        selected
        disabled
      >
        Anrede*
      </option>
      <option value="MR">Herr</option>
      <option value="MS">Frau</option>
      <option value="DIVERSE">Divers</option>
      <option value="COMPANY">Firma</option>
      <option value="FAMILY">Familie</option>
    </select>
  </VeeField>
  <VeeErrorMessage name="salutation" />
</template>
<script setup lang="ts">
import { useCartFormData } from '~/composables/states';
type InputClass = string;
defineProps({
  inputClass: {
    type: String as PropType<InputClass>,
    default: 'inp sm',
  },
});
const emit = defineEmits(['changeSalutations']);

function change(value: string | undefined) {
  if (value != 'COMPANY') {
    useCartFormData().value.invoiceAddress!.company = '';
  }
  emit('changeSalutations', value);
}

if (useCartFormData().value.invoiceAddress?.title) {
  change(useCartFormData().value.invoiceAddress!.title);
}
</script>

<style scoped lang="postcss">
select {
  @apply appearance-none;
}
</style>
